import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing-section');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="relative bg-teal-700 text-white overflow-hidden" data-id="element-70">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-71"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24 relative z-10" data-id="element-72">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-73">
          {/* Text Content */}
          <div className="space-y-8" data-id="element-74">
            <div className="inline-flex items-center gap-2 bg-teal-800/50 px-4 py-2 rounded-full border border-teal-500/30 backdrop-blur-sm" data-id="element-75">
              <span className="w-2 h-2 bg-orange-400 rounded-full animate-pulse" data-id="element-76"></span>
              <span className="text-sm font-medium text-teal-100" data-id="element-77">
                Para mujeres latinas en USA
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight tracking-tight" data-id="element-78">
              Tu primer cliente no viene de un logo.
            </h1>

            <p className="text-xl md:text-2xl text-teal-100 font-light max-w-lg" data-id="element-79">
              5 horas por semana. Un plan que sí cabe en tu vida.
            </p>

            <p className="text-lg text-teal-200/90 max-w-xl" data-id="element-80">
              En 30 días, con el <strong data-id="element-81">Método 3x3</strong>, consigues tus
              primeras conversaciones, tu primer cobro y tu primer cliente con
              un servicio simple.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4" data-id="element-82">
              <button onClick={scrollToPricing} className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-4 px-8 rounded-xl text-lg transition-all transform hover:scale-105 shadow-lg shadow-orange-500/20 flex items-center justify-center gap-2" data-id="element-83">
                Quiero el PDF
                <ArrowRight className="w-5 h-5" data-id="element-84" />
              </button>
              <p className="text-sm text-teal-200 mt-2 sm:mt-0 sm:ml-4 flex items-center justify-center sm:justify-start" data-id="element-85">
                <CheckCircle className="w-4 h-4 mr-2 text-teal-300" data-id="element-86" />
                Acceso inmediato
              </p>
            </div>
          </div>

          {/* Image */}
          <div className="relative mx-auto lg:ml-auto w-full max-w-md lg:max-w-full" data-id="element-87">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white/10 transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-88">
              <img src="https://cdn.magicpatterns.com/uploads/1G6xsHQxfsXZKXee1M9mrF/heylloyd-image-1769194425902.png" alt="Side Hustle Express en un teléfono móvil" className="w-full h-auto object-cover" data-id="element-89" />
              <div className="absolute inset-0 bg-gradient-to-t from-teal-900/60 to-transparent" data-id="element-90"></div>
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 bg-white text-teal-900 p-4 rounded-lg shadow-xl max-w-xs hidden md:block" data-id="element-91">
              <div className="flex items-center gap-3" data-id="element-92">
                <div className="bg-teal-100 p-2 rounded-full" data-id="element-93">
                  <CheckCircle className="w-6 h-6 text-teal-600" data-id="element-94" />
                </div>
                <div data-id="element-95">
                  <p className="font-bold text-sm" data-id="element-96">Sin inventario</p>
                  <p className="text-xs text-gray-500" data-id="element-97">
                    Empieza con lo que sabes
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}